import {
    useGetRequest,
    RequestResponse,
    PostRequest,
    DeleteRequest,
    RequestPromise,
    PutRequest,
} from "../../hook/useRequest";
import {AppSettings} from "../../AppSettings";
import {getToken} from "../../utils/storage/Token";
import {ExpenseDBInterface} from "./Interfaces/ExpenseInterface";
import axios from "axios";

const API_URL_EXPENSE = AppSettings.API_FREELANCERIE + "/expense";

const useFetchExpense = (idUser: number, month: number, year: number, forceUpdated = 0): RequestResponse => {
    const config = {headers: {Authorization: getToken()}};
    return useGetRequest(`${API_URL_EXPENSE}/${idUser.toString()}&${month.toString()}&${year.toString()}`, forceUpdated, config);
};

const UpdateExpense = (idExpense: number, expense: ExpenseDBInterface): RequestPromise => {
    const config = {headers: {Authorization: getToken()}};
    return PutRequest(`${API_URL_EXPENSE}/${idExpense.toString()}`, expense, config);
};

const AddExpense = (idUser: number, expense: ExpenseDBInterface): RequestPromise<{id: number}> => {
    const config = {headers: {Authorization: getToken()}};
    return PostRequest<{id: number}>(`${API_URL_EXPENSE}/${idUser.toString()}`, expense, config);
};

const DeleteExpense = (idExpense: number): RequestPromise => {
    const config = {headers: {Authorization: getToken()}};
    return DeleteRequest(`${API_URL_EXPENSE}/${idExpense.toString()}`, config);
};

const UploadExpense = (idUser: number, idExpense: number, file: File): RequestPromise => {
    const formData = new FormData();
    formData.append(file.name, file);
    const config = {
        headers: {
            Authorization: getToken(),
            "content-type": file.type,
        },
    };
    return PostRequest(`${API_URL_EXPENSE}/upload_expense/${idUser}&${idExpense}`, formData, config);
};

/**
 * Télécharge l'archive ZIP des dépenses d'un mois (récapitulatif PDF + justificatifs)
 * @param idUser identifiant utilisateur
 * @param month mois (0-11)
 * @param year année
 */
const DownloadExpenseArchive = async (idUser: number, month: number, year: number): Promise<void> => {
    const url = `${API_URL_EXPENSE}/archive/${idUser}&${month}&${year}`;
    const response = await axios(url, {
        method: "GET",
        headers: { Authorization: getToken() },
        responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/zip" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Depenses_${month + 1}_${year}.zip`;
    link.click();
    URL.revokeObjectURL(link.href);
};

export {useFetchExpense, AddExpense, UpdateExpense, DeleteExpense, UploadExpense, DownloadExpenseArchive};
